export default function initLoginForm () : void {
    const $userLogin = document.getElementById('user_login');
    const $userPass = document.getElementById('user_pass');
    const $userPassLabel = document.querySelector('#loginform .login-password label');
    const $lostPass = document.querySelector('#loginform .lost-password');
    $userLogin?.setAttribute('placeholder', 'Votre identifiant');
    $userPass?.setAttribute('placeholder', 'Votre mot de passe');
    if ($lostPass && $userPassLabel) {
        insertAfter($lostPass, $userPassLabel);
    }
}

function insertAfter(newNode: Node, existingNode: Node) {
    existingNode.parentNode?.insertBefore(newNode, existingNode.nextSibling);
}